import {Component, OnInit, ViewChild} from '@angular/core';
import {MatSort} from '@angular/material/sort';
import {MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import {SnackBarIconService} from '../shared/snack-bar-icon/snack-bar-icon.service';
import {Department} from '../models/department';
import {DepartmentDialogComponent} from './dialogs/department-dialog/department-dialog.component';
import {DepartmentService} from '../services/department.service';
import {Subscription} from 'rxjs';
import {ConfirmComponent} from '../shared/dialogs/confirm/confirm.component';
import {AuthService} from '../services/auth.service';
import {Router} from '@angular/router';
import {ContextService} from '../services/context.service';

@Component({
  selector: 'app-department',
  templateUrl: './department.component.html',
  styleUrls: [ './department.component.scss' ],
  entryComponents: [
    DepartmentDialogComponent
  ]
})
export class DepartmentComponent implements OnInit {

  private sub: Subscription;
  public dataSource: MatTableDataSource<any>
  public displayedColumns: string[] = [ 'icon', 'name', 'edit', 'delete' ];

  public contexts: any[] = [];

  constructor (
    private _departmentService: DepartmentService,
    private dialog: MatDialog,
    private snackBar: SnackBarIconService,
    private _authService: AuthService,
    public _contextService: ContextService,
    private router: Router) {

    if (!this._authService.isAdmin) {
      this.router.navigate([ 'home' ]);
    }

    this.loadAllContexts();

  }

  @ViewChild(MatSort, {static: true}) sort: MatSort;

  ngOnInit () {
  }

  ngOnDestroy () {
    if (this.sub)
      this.sub.unsubscribe();
  }

  applyFilter (filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  async loadAllContexts(){
    this.contexts = await this._contextService.loadAllContexts();
    console.log(JSON.stringify(this.contexts))
  }

  openDialog (entity) {

    let data: Department = new Department();

    if (entity) {
      data = entity;
    } else {
      data.context_id = this.selectedContext
    }

    this.dialog.open(DepartmentDialogComponent, {
      width: '800px',
      height: '600px',
      panelClass: 'custom-dialog-container',
      data: data
    });
  }

  delete (element) {
    let dialogRef = this.dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme", message: element.name + "<br><br>Excluir esta Departamento?"}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {

        this._departmentService.delete(element.id)
          .then(
            () => {
              this.snackBar.openSnackBar("Sucesso!", '', 'success')
            }
          )
          .catch(
            (error) => {console.log("delete regional error: " + error.message)}
          )
      }
    })
  }

  public selectedContext: any;

  contextChange (event) {
    this.selectedContext = event
    console.log(this.selectedContext)
    this.loadDepartments(this.selectedContext)
  }

  loadDepartments (context_id) {

    try {
      this.sub = this._departmentService.select(context_id)
        .subscribe((result) => {

          let array = result.map(item => {
            let entity = new Department();
            entity.id = item.payload.doc.id;
            entity.context_id = item.payload.doc.data().context_id;
            entity.name = item.payload.doc.data().name;
            entity.short = item.payload.doc.data().short;
            entity.text = item.payload.doc.data().text;
            return entity;
          });

          this.dataSource = new MatTableDataSource(array);
          this.dataSource.sort = this.sort;
        })

    } catch (err) {
      console.log(err.message);
    }

  }

}
